// Coach sign-in email allowlist. Mirrored in firestore.rules (isCoachEmail) —
// update BOTH places when staff changes. Additional coaches can also be
// promoted at runtime from the coach dashboard (users doc role), no code
// change needed.
export const COACH_EMAILS = [
  'davesfx@gmail.com',
  'willard.bowlingcoach@gmail.com',
  'dcbowls300@gmail.com',
];

export const isCoachEmail = (email?: string | null): boolean =>
  !!email && COACH_EMAILS.includes(email.toLowerCase());
